module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.f40598dd.ttf";